import { Button, Form, InputNumber, Modal } from "antd";
import {
  btnStyle,
  ContainerModalBtn,
  formStyle,
  layout,
} from "../styles";
import { completarCotasAptoService } from "../../../services/completarCotasAptoService";
import { useState } from "react";

interface ModalCompletarCotasProps {
  aptoId?: number | null;
  handleFechar: () => void;
  isModalOpen: boolean;
  onSuccess: (message: string) => void;
  onError: (message: string) => void;
}

export default function ModalCompletarCotas({
  aptoId,
  handleFechar,
  isModalOpen,
  onSuccess,
  onError,
}: ModalCompletarCotasProps) {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const quantidadeCotas = Form.useWatch("quantidadeCotas", form);
  const quantidadeValida =
    typeof quantidadeCotas === "number" && quantidadeCotas >= 1;

  const onFinish = async (values: { quantidadeCotas: number }) => {
    if (!aptoId) {
      onError("Nao foi possivel identificar o apartamento.");
      return;
    }

    try {
      setIsLoading(true);
      const response = await completarCotasAptoService({
        aptoId,
        quantidadeCotas: Number(values.quantidadeCotas),
      });

      if (response.totalCotasCriadas > 0) {
        onSuccess(
          `${response.totalCotasCriadas} cota${
            response.totalCotasCriadas > 1 ? "s foram" : " foi"
          } criada${response.totalCotasCriadas > 1 ? "s" : ""} com sucesso.`
        );
      } else {
        onSuccess("O apartamento ja possui a quantidade de cotas informada.");
      }

      form.resetFields();
      handleFechar();
    } catch (error: any) {
      const mensagemArray = error?.message;
      const mensagem =
        (Array.isArray(mensagemArray) ? mensagemArray[0] : mensagemArray) ||
        error?.error ||
        error?.response?.data?.message ||
        "Nao foi possivel completar as cotas do apartamento.";

      onError(mensagem);
    } finally {
      setIsLoading(false);
    }
  };

  const onCancel = () => {
    form.resetFields();
    handleFechar();
  };

  return (
    <Modal open={isModalOpen} onCancel={onCancel} footer={null} destroyOnClose>
      <Form
        {...layout}
        form={form}
        name="completarCotasApto"
        onFinish={onFinish}
        style={formStyle}
      >
        <h1>Completar cotas</h1>

        <Form.Item
          name="quantidadeCotas"
          label="Total de cotas"
          className="formItems"
          rules={[
            { required: true, message: "Informe a quantidade total de cotas" },
          ]}
        >
          <InputNumber min={1} style={{ width: "100%" }} />
        </Form.Item>

        <ContainerModalBtn>
          <Button
            htmlType="submit"
            disabled={!quantidadeValida}
            loading={isLoading}
            style={btnStyle}
            size="large"
            type="primary"
          >
            Completar
          </Button>
        </ContainerModalBtn>
      </Form>
    </Modal>
  );
}
